export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0007s_0000_Black-&-White-8.74d20e92.png";